import { CornerDownRight } from "lucide-react";

export const ReviewReply = ({ reply, provider, testid, className = "" }) => {
  if (!reply || reply.hidden) return null;
  return (
    <div className={`border-l-2 border-primary/40 bg-primary/[0.04] rounded-sm pl-3 pr-2 py-2 ${className}`} data-testid={testid}>
      <p className="text-xs font-semibold flex items-center gap-1 text-foreground/80">
        <CornerDownRight className="w-3 h-3 text-primary" />Reply from {provider || "the provider"}
      </p>
      <p className="text-sm text-foreground/80 mt-0.5">{reply.text}</p>
    </div>
  );
};
